<template>
  <div>
    <TableWrapper :loading="loadingWallet" errorMsg="">
      <template slot="content">
        <div class="p-4">
          <div class="border-bottom pb-3 mb-4 flex__between flex-wrap">
            <div class="">
              <h4 class="head4">
                {{ wallet.currency || "NGN" }}
                {{
                  wallet.balance ? Number(wallet.balance).toLocaleString() : 0
                }}
              </h4>
              <p class="call-name pt-2">Current NGN Wallet Banlace</p>
            </div>

            <div class="">
              <h4 class="head4">
                {{
                  customer.total_credit_loaded
                    ? toCurrency(customer.total_credit_loaded)
                    : 0
                }}
              </h4>
              <p class="call-name pt-2">Total Credit Loaded</p>
            </div>

            <div v-if="role === 'Blusalt Admin'">
              <AddCreditButton
                :clientid="customer.client_id"
                :refetch="refetch"
              />
            </div>
          </div>

          <h5 class="font-weight-bold">Wallet Info</h5>

          <div class="row profile pt-3">
            <div class="col-lg-4 col-12">
              <p>Account Name</p>
              <h5>{{ wallet.account_name || "None" }}</h5>
            </div>

            <div class="col-lg-4 col-12">
              <p>Account Number</p>
              <div class="d-flex">
                <h5 class="m-0">
                  {{ wallet.account_number || "None" }}
                </h5>
                <img
                  v-if="wallet.account_number"
                  src="/assets/img/copy.svg"
                  class="pointer ml-3"
                  alt=""
                  @click="copy(wallet.account_number || '')"
                />
              </div>
            </div>

            <div class="col-lg-4 col-12">
              <p>Bank Name</p>
              <h5>{{ wallet.bank_name || "None" }}</h5>
            </div>
          </div>
        </div>
      </template>
    </TableWrapper>
    <div class="d-flex justify-content-between">
      <FilterWrapper>
        <template slot="filterForm">
          <TransactionFilter
            :loading="loading"
            :rLoading="rLoading"
            :submitFilter="refetch"
            :clearFilter="() => clearFilter('creditRef')"
          />
        </template>
      </FilterWrapper>
      <div>
        <button class="btn btn-lg btn-secondary-inverted" @click="download()">
          <span>
            <img src="/assets/img/icons/document-download.svg" alt="" />
          </span>
          Export CSV
        </button>
      </div>
    </div>
    <TableWrapper
      :loading="loading"
      :errorMsg="errorMsg"
      :refetch="refetch"
      :isEmpty="isEmpty"
      emptyTitle="No Credit History"
    >
      <div class="w-100 px-3 pt-4" slot="content">
        <h5 class="font-weight-bold">Account Credit Log</h5>
        <v-server-table
          ref="creditRef"
          class="v-table row-pointer"
          :data="credits"
          :columns="columns"
          :options="options"
          @loaded="onLoaded"
        >
          <template slot="action" slot-scope="{ row }">
            <span :class="statusColor(row.action)">
              {{ titleCase(row.action) }}
            </span>
          </template>
          <template slot="amount" slot-scope="{ row }">
            {{ toCurrency(row.amount) }}
          </template>
          <template slot="status" slot-scope="{ row }">
            <span :class="statusColor(row.status)">
              {{ titleCase(row.status) }}
            </span>
          </template>
          <template slot="createdAt" slot-scope="{ row }">
            {{ timeDateFormat(row.createdAt).date }}
            {{ timeDateFormat(row.createdAt).time }}
          </template>
        </v-server-table>
      </div>
      <!-- <template slot="content">
        <div v-if="logs.data" class="px-3">
          <h5 class="font-weight-bold mt-3">Account Credit Log</h5>
          <AccountCreditLog :logs="logs" />
        </div>
      </template> -->
    </TableWrapper>
  </div>
</template>

<script>
const tableHeadings = {
  reference: "Reference",
  action: "Type",
  amount: "Amount",
  currency: "Currency",
  status: "Status",
  createdAt: "Date Created",
};

import {
  notifications,
  componentData,
} from "../../../../../public/assets/mixins";
import TransactionFilter from "../../../../components/filters/TransactionFilter.vue";
import {
  getRequestData,
  statusColor,
  tableOptions,
  timeDateFormat,
  titleCase,
  toCurrency,
} from "../../../../components/utils/helpers";
import AddCreditButton from "../../buttons/AddCreditButton/AddCreditButton";
import AccountCreditLog from "../AccountCreditLog/AccountCreditLog";

export default {
  data() {
    return {
      isEmpty: false,
      credits: [],
      ...tableOptions(tableHeadings, 25),
    };
  },
  mixins: [notifications, componentData],
  name: "CustomerWallet",
  props: ["customer", "role", "clientid", "loadingWallet"],
  components: {
    AddCreditButton,
    AccountCreditLog,
    TransactionFilter,
  },
  methods: {
    toCurrency,
    timeDateFormat,
    titleCase,
    statusColor,
    async copy(value) {
      const copied = this.copyToClipboard(value);
      copied && this.showSuccessNotification("Account Number Copied!");
    },
    refetch(filters) {
      this.handleRefetch(filters, this.fetchCustomersDetails, "creditRef");
    },
    async fetchCustomersDetails() {
      this.options.requestFunction = async (data) => {
        try {
          this.setLoading(true);
          const params = {
            ...data,
            ...this.filters,
            status: this.filters?.status?.value,
          };
          const response = await this.$store.dispatch(
            "customer/getSingleCustomerCreditLogs",
            { clientid: this.clientid, params }
          );

          const creditLogs = response?.data || [];

          const count = response?.total;

          return { ...response, count, total: count, data: creditLogs };
        } catch (error) {
          this.setError(error);
        }
      };
    },
    async download() {
      try {
        this.rLoading = true;
        const request = getRequestData(this.$store, this.filters, {});
        const response = await this.$store.dispatch(
          "customer/getSingleCustomerCreditLogs",
          {
            ...request,
            clientid: this.clientid,
          }
        );

        const data = response?.data || [];
        this.downloadReport(tableHeadings, data);
        this.rLoading = false;
      } catch (e) {
        this.rLoading = false;
        this.showErrorLoginNotification("Error Downloading Report");
      }
    },
  },
  computed: {
    wallet() {
      const wallets = this.customer.customer_wallet || [];
      return wallets && wallets.length ? wallets[0] : {};
    },
  },
  created() {
    this.fetchCustomersDetails();
  },
  mounted() {
    this.columns = Object.keys(tableHeadings).map((keyVal) => keyVal);
  },
  watch: {
    options: function (val) {
      console.log(val);
    },
  },
};
</script>
